@let isOccupier = isOccupierSg();
@let description = descriptionSg();
@let isJointUseMethodology = isJointUseMethodologySg();

<atn-ds-centered-overlay type="wide">
  <div class="atn-space-room-data-modal">
    <atn-ds-widget title="Add Organization Assignment">
      <div actions>
        <i
          class="atn-icon atn-close atn-red"
          (click)="cancelClickHandler()"
        ></i>
      </div>

      <div class="atn-space-room-data-modal__content">
        @let entities = organizationEntityOptionsSg();
        @for (entity of entities; track entity.id; let isRequired = $last) {
          <atn-ds-select-single
            [label]="entity.name"
            [items]="entity.options"
            [config]="{
              overlay: { minSearchCharacters: 1, hasSearch: true },
            }"
            [value]="selectionLookupSg()[entity.id]"
            (valueChange)="handleOrganizationSelection(entity.id, $event)"
            [required]="isRequired"
            placeholder="Select {{ entity.name.toLowerCase() }}"
          />
        }

        <atn-ds-text-area
          label="Description"
          placeholder="Enter a description"
          [value]="description"
          (valueChange)="updateOrgAssignment({ description: $event })"
          [styleOverrides]="{
            height: '100px',
            resize: 'vertical',
          }"
        ></atn-ds-text-area>

        <atn-ds-radio-options
          label="Is Occupier?"
          (change)="updateOrgAssignment({ isOccupier: !!$event })"
        >
          <atn-ds-radio-option
            [radioValue]="true"
            name="Yes"
            [isActive]="isOccupier"
          />
          <atn-ds-radio-option
            [radioValue]="false"
            name="No"
            [isActive]="!isOccupier"
          />
        </atn-ds-radio-options>

        @if (isJointUseMethodology) {
          <atn-ds-notice
            class="atn-space-room-data-modal__notice"
            [style]="DisplayStyle.Warning"
            description="Changing Occupier may have impact on Functional Usage of this Space Record"
          />
        }

      </div>

      <div
        class="atn-space-room-data-modal__footer"
        footer
      >
        <atn-ds-button
          type="transparent"
          (click)="cancelClickHandler()"
          >Cancel</atn-ds-button
        >
        <atn-ds-button
          (click)="saveClickHandler()"
          [loading]="
            recordAssignedOrgsEc.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal()
          "
          [disabled]="!leafOrganizationSelectedSg()"
          >Save</atn-ds-button
        >
      </div>
    </atn-ds-widget>
  </div>
</atn-ds-centered-overlay>
